import {HttpClient} from "../../service/httpClient/HttpClient";
import {PlayModeTypes} from "../../pages/games/PlayModeTypes";
import axios from "axios";

export class GameService {

    constructor() {
        this.httpClient = new HttpClient()
    }

    getGameList(page, size, title, playMode, status) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `games`,
                {
                    page,
                    size,
                    title: title && title.length > 0 ? title : null,
                    "playMode": playMode && playMode !== "ALL" && playMode.length > 0 ? playMode : null,
                    "status": status && status !== "ALL" && status.length > 0 ? status : null,
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewGame(title, playMode) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `games`,
                {
                    title,
                    "playMode": playMode && playMode.length > 0 &&
                    playMode === PlayModeTypes.MULTI.id ? PlayModeTypes.MULTI.id : PlayModeTypes.SINGLE.id,
                }
            ).then(resolve).catch(reject)
        })
    }

    getGameBasicInfo(gameId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `games/${gameId}/information`
            ).then(resolve).catch(reject)
        })
    }

    updateGameBasicInfo(gameId, title) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `games/{id}/information`,
                {},
                {
                    title
                }
            ).then(resolve).catch(reject)
        })
    }

    getGameSettings(gameId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `games/${gameId}/settings`
            ).then(resolve).catch(reject)
        })
    }

    updateGameSettings(gameId, playMode) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `games/${gameId}/settings`,
                {},
                {
                    playMode
                }
            ).then(resolve).catch(reject)
        })
    }

    getGameAdmissionSettings(gameId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `games/${gameId}/admission-settings`
            ).then(resolve).catch(reject)
        })
    }

    updateGameAdmissionSettings(gameId, status) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `games/${gameId}/admission-settings`,
                {},
                {
                    status
                }
            ).then(resolve).catch(reject)
        })
    }

    getGameThumbnail(gameId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `games/${gameId}/thumbnail`
            ).then(resolve).catch(reject)
        })
    }

    updateGameThumbnail(gameId) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `games/${gameId}/thumbnail`,
                {},
                {}
            ).then(resolve).catch(reject)
        })
    }

    getGameDescription(gameId) {

        const gameContentState = this.httpClient.get(
            `games/${gameId}/description`
        );

        const requests = [
            gameContentState
        ]

        return new Promise((resolve, reject) => {
            axios.all(requests)
                .then(axios.spread((gameContent) => {
                        resolve({
                            gameContent
                        })
                    })
                ).catch(reject)
        })
    }

    updateGameDescription(gameId, contents) {

        const _content = []
        contents.map((item, index) => {
            _content.push({
                ...item,
                priority: index
            })
        })

        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `games/${gameId}/description`,
                {},
                _content
            ).then(resolve).catch(reject)
        })

    }

}